registerComponent("sections/private", function (component) {
/**
 * A entrada na rolagem (ADR 0051): as peças marcadas `.entrada` no HTML entram
 * quando a seção chega na tela — numa linha escalonada no desktop, uma a uma
 * abaixo do degrau. Ver `Asa.armarEntrada` em assets/.scripts/asa.js e
 * assets/.styles/_entrada.less.
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

Asa.armarEntrada([component], '.entrada');

});
